import { Issue } from '@damofire/data-watson';
import { WarehouseLayoutModel } from './warehouse-layout.model';

export function filterLayoutIssue(issue: Issue, model: WarehouseLayoutModel): boolean {
  const priorityMatch = !model.priorityFilter.length || model.priorityFilter.includes(issue.riskLevel?._id);
  const componentMatch = !model.componentFilter.length || model.componentFilter.includes(issue.component?._id);
  const withNotesMatch = !model.withNotes || issue.notes?.length > 0;
  const sectionMatch = !model.section || issue.asset?.section === model.section || +model.section === -1;

  return priorityMatch && componentMatch && withNotesMatch && sectionMatch;
}
